export default "__VITE_ASSET__BMjbaLAD__"